//import Vue from 'vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default (app) => {
    app.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
}
